import { TypeIdSchema } from '@unipile/db';
import { Type, type Static } from '@sinclair/typebox';
import { PublicApiKeySchema } from './api-key.schema';

export const ApiKeysResponseSchema = Type.Object({
  object: Type.Literal('ApiKeys', { description: 'The type of the returned collection.' }),
  data: Type.Array(PublicApiKeySchema, { description: 'The Account API Keys in the current page.' }),
  has_more: Type.Boolean({ description: 'Whether more API Keys are available after the current page.' }),
});

export type ApiKeysResponse = Static<typeof ApiKeysResponseSchema>;

export const CreateApiKeyResponseSchema = Type.Object({
  object: Type.Literal('ApiKey', { description: 'The type of the created object.' }),
  id: TypeIdSchema('apiKey', { description: 'The unique public ID of the created API Key.' }),
  api_key: Type.String({
    description: 'The secret API Key token. It is returned only once and must be stored securely.',
  }),
});

export type CreateApiKeyResponse = Static<typeof CreateApiKeyResponseSchema>;
